module.exports = __webpack_public_path__ + "static/media/loc2_img17.d82adbe9.jpg";